import PropTypes from 'prop-types';

import useMenuItems from 'src/hooks/useMenuItems';
import DashboardNavigation from '../DashboardNavigation';

const DashboardNavigationCMenu = (props) => {
	const { menuItems, menuLoading } = useMenuItems();

	return (
		<DashboardNavigation
			{...props}
			menuItems={menuItems}
			menuLoading={menuLoading}
		/>
	);
};

DashboardNavigationCMenu.propTypes = {
	drawerOpen: PropTypes.bool,
};

export default DashboardNavigationCMenu;
